import React, {useEffect, useRef} from 'react';
import PropTypes from "prop-types";
import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';

import './date_picker.scss';

const uniq_id = 'datepicker-field-' + Date.now() + '-' + Math.floor(Math.random() * 100);
let picker = undefined;

function DatePicker(
    {
        date,
        onChange,
        minDate,
        maxDate,
        with_reset = false,
        range = false
    }
) {
    const field = useRef();

    useEffect(() => {
        const options = {
            dateFormat: 'MMMM dd, yyyy',
            locale: localeEn,
            firstDay: 1,
            weekends: [6, 0],
            autoClose: true,
            range,
            onSelect: function (data) {
                if (range && data && Array.isArray(data.date)) {
                    if (data.date.length === 2) {
                        const date0 = data.date[0].getTime() / 1000;
                        const date1 = data.date[1].getTime() / 1000;
                        onChange({
                            from: date0 > date1 ? date1 : date0,
                            till: date0 < date1 ? date1 : date0,
                        });
                    }
                } else if (data && data.date) {
                    onChange(data.date.getTime() / 1000);
                } else {
                    onChange(null);
                }
            }
        };
        if (Number.isInteger(minDate)) {
            options.minDate = minDate * 1000;
        }
        if (Number.isInteger(maxDate)) {
            options.maxDate = maxDate * 1000;
        }
        if (range) {
            options.multipleDatesSeparator = ' - ';
        }
        picker = new AirDatepicker(field.current, options);
        if (range && Array.isArray(date)) {
            picker.selectDate(date.map(d => d * 1000), {silent: true});
        } else if (!range && Number.isInteger(date)) {
            picker.selectDate(date * 1000, {silent: true});
        }

        return () => {
            picker.destroy();
        }
    }, []);
    useEffect(() => {
        if (Number.isInteger(minDate)) {
            picker.update({minDate: minDate * 1000}, {silent: true});
        }
    }, [minDate]);
    useEffect(() => {
        if (Number.isInteger(maxDate)) {
            picker.update({maxDate: maxDate * 1000}, {silent: true});
        }
    }, [maxDate]);
    useEffect(() => {
        if (range && Array.isArray(date)) {
            picker.selectDate(date.map(d => d * 1000), {silent: true});
        } else if (!range && Number.isInteger(date)) {
            picker.selectDate(date * 1000, {silent: true});
        }
    }, [date]);

    function renderReset() {
        if (with_reset && date) {
            return (
                <i
                    className='datepicker-reset fas fa-times-circle'
                    onClick={() => {
                        picker.clear();
                    }}
                />
            );
        }

        return null;
    }

    return (
        <div className='picker-block' id={'picker-block-' + uniq_id}>
            <input
                ref={field}
                type="text"
                className="date-picker-input"
                id={uniq_id}
                placeholder="Pick a date"
            />
            <i className="far fa-calendar-alt calendar-icon"/>
            {renderReset()}
        </div>
    );
}

DatePicker.propTypes = {
    date: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
    onChange: PropTypes.func.isRequired,
    minDate: PropTypes.number,
    maxDate: PropTypes.number,
    with_reset: PropTypes.bool,
    range: PropTypes.bool
};

export default DatePicker;
